/**
 * KeyboardShortcutsPanelWrapper Component
 * Wrapper for Keyboard Shortcuts Panel
 */

import React from 'react';
import { KeyboardShortcutsPanel } from '../../KeyboardShortcutsPanel';

export const KeyboardShortcutsPanelWrapper = ({
  isOpen,
  onClose,
}) => {
  return (
    <KeyboardShortcutsPanel
      isOpen={isOpen}
      onClose={onClose}
    />
  );
};

export default KeyboardShortcutsPanelWrapper;
